import { VertButton } from '@vertem-core/vertice-ds';
import React, { useEffect, useState } from 'react';
import { Col, Flex, Modal, Row, Typography } from 'antd';
import { FaCopy } from 'react-icons/fa';

const ModalResultSkin = ({ isOpen, setIsOpenModal, data, campaignInfos }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  }, [copied]);

  const downloadJSON = (data) => {
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = `skin-${campaignInfos.campaignId}-${campaignInfos.catalogId}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      open={isOpen}
      onCancel={() => setIsOpenModal(false)}
      centered
      footer={
        <Flex
          justify="space-between"
          align="center"
          style={{ padding: '0 24px 24px 24px' }}
          gap={16}
        >
          <VertButton
            htmlType="button"
            onClick={() => setIsOpenModal(false)}
            className="ant-btn ant-btn-danger"
            block
            type="default"
          >
            Fechar
          </VertButton>
          <VertButton
            htmlType="button"
            onClick={() => downloadJSON(data)}
            target="_blank"
            className="ant-btn ant-btn-danger"
            block
            type="highlight"
          >
            Download
          </VertButton>
        </Flex>
      }
      style={{
        maxWidth: '800px',

        padding: '24px',
        borderRadius: '8px',
        boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
      }}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Typography.Text strong>
            Resultado para Campanha{' '}
            {`${campaignInfos.campaignId} - ${campaignInfos.catalogId}`}{' '}
          </Typography.Text>
          <VertButton
            htmlType="button"
            onClick={() => {
              setCopied(true);
              window.navigator.clipboard.writeText(
                JSON.stringify(data, null, 2)
              );
            }}
            size="small"
            style={{ margin: '8px 0' }}
            icon={copied ? <FaCopy /> : <></>}
          >
            {copied ? 'Copiado!' : 'Copiar JSON'}
          </VertButton>

          <pre
            style={{
              backgroundColor: '#f5f5f5',
              height: '300px',
              overflow: 'hidden',
              overflowY: 'auto',
              width: '80%',
              padding: '16px',
              borderRadius: '8px',
            }}
          >
            {JSON.stringify(data, null, 2)}
          </pre>
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalResultSkin;
